<template>
  <el-table-column
    prop="strange_belongings_tool.name"
    sortable="custom"
    label="Idegen tulajdon"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.strange_belongings_tool">{{ scope.row.strange_belongings_tool.name }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'strange_belongings_tool.name',
  };
</script>
